'use strict';

/**
 * Automatically click the input button to redirect the user to
 * the SSO
 */
ready(function () {
    document.getElementById('postLoginSubmitButton').click();
});
